<template>
  <v-card color="rgba(41, 41, 47, 0.8)">
    <v-card-text>
      <v-container v-if="crossSectionData">
        <v-row class="mt-2">
          {{ $t("LineWorkparamater") }}
        </v-row>
        <v-row>
          <v-table class="lineworks-table" density="compact" style="background-color: rgba(41, 41, 47, 0)">
            <tbody>
              <tr>
                <td style="width: 50%">
                  {{ $t("WidthofLineWork") }} {{ $t("Left") }}
                </td>
                <td>
                  <DistanceSettingInput hide-details density="compact" v-model="crossSectionData.leftWidth"
                    :min-value="1" :max-value="999.999" :decimal-length="3" :step="0.001" />
                </td>
              </tr>
              <!-- 道路幅_右 -->
              <tr>
                <td>
                  <span>{{ $t("WidthofLineWork") }}</span>
                  {{ $t("Right") }}
                </td>
                <td>
                  <DistanceSettingInput hide-details density="compact" v-model="crossSectionData.rightWidth"
                    :min-value="1" :max-value="999.999" :decimal-length="3" :step="0.001" />
                </td>
              </tr>
              <!-- 測点間隔 -->
              <tr v-if="!isSima">
                <td>
                  {{ $t("STATION_INTERVAL") }}
                </td>
                <td>
                  <DistanceSettingInput hide-details density="compact" v-model="crossSectionData.interpolationPitch"
                    :min-value="1" :max-value="999.999" :decimal-length="3" :step="0.001" />
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>


<script>
import DistanceSettingInput from "../DistanceSettingInput.vue";

export default {
	name: "LineWorksCrossSectionInput",
	components: {
		DistanceSettingInput,
	},
	props: {
		crossSectionData: {
			type: Object,
			default: () => ({}),
		},
		isSima: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.mt-0 {
  margin-top: 0;
}

.mt-2 {
  margin-top: 2em;
}

.pt-2 {
  padding-top: 2em;
}

.full-width {
  width: 100%;
}

.lineworks-table :deep(table) {
  width: 100%;
  table-layout: fixed;
}
</style>